import React, { useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { FontStyle, JobDisplays } from "../constants";
import { isLoggedIn } from "../utils/utils";
import * as apiService from "../service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import ResumePreview from "./ResumeComponents/ResumePreview";
import FloatWrapper, {
  CloseButton,
  FadeFloatWrapper,
  FloatTitle,
} from "./FloatWrapper";

const styles = {
  outer: {
    width: "100%",
    maxHeight: "80%",
    // height: "100%",
    position: "relative",
  },
  container: {
    width: "100%",
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    ...FontStyle.body,
    minWidth: "",
    // maxHeight: windowMinusNavbar,
    overflowY: "scroll",
  },
};
const ResumeFloatPreview = ({ show, resumeId, fileType, handleClose }) => {
  return (
    <FadeFloatWrapper show={show} onClick={handleClose}>
      <Stack
        sx={{
          ...styles.outer,
          maxWidth: "600px",
          px: 4,
        }}
        direction="row"
        spacing={2}
        onClick={(e) => {
          e.stopPropagation();
        }}>
        <Stack
          sx={{
            ...styles.container,
          }}
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={2}>
          <ResumePreview resumeId={resumeId} fileType={fileType} />
        </Stack>
      </Stack>
      <CloseButton onClick={handleClose} />
    </FadeFloatWrapper>
  );
};

export default ResumeFloatPreview;
